import type { AppData } from '../../types/app_data';
import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';
import { carsSpecialNextStep } from '../common/addcars';

export const CarsStepBeforeOnboardingStep: Step = {
  id: 'cars',
  pathname: '/cars',
  excludeFromProgressCalculation: true,
  canShow: (appData: AppData) => {
    /**
     * Return false: in abTest experiment && is not in new flow(garage/dwep) || isOnboardingLite
     */
    if (appData.isOnboardingLite) {
      return false;
    }
    if (appData.selectedService?.insurance) {
      return false;
    }

    if (appData.isFromMAL) {
      return false;
    }

    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    return !!(appData.selectedService?.garage || appData.selectedService?.dwep || appData.selectedService?.refi);
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => {
    // If in new flow(garage/dwep) && saves car data in local
    if (
      ((appData.selectedService?.garage || appData.selectedService?.dwep || appData.selectedService?.refi) &&
        appData.selectedCars?.length) ||
      appData.addingNewCar
    ) {
      return true;
    }
    return !!appData.syncedPolicyData;
  },
  specialNextStep: carsSpecialNextStep,
  category: () => StepCategory.Cars,
};
